// ============================================================================
// buildMenu — builds the sidebar from the module manifests.
// A menu item shows only when:
//   1. its module is switched ON by HQ (app_modules table), and
//   2. the person has one of the item's roles, and
//   3. for CNOM-only items, the person is a CNOM member (or HQ).
// Sections always appear in the same order; empty sections are left out.
// ============================================================================

export const SECTION_ORDER = ['Home', 'Redeem', 'Restore', 'Rebuild', 'CNOM Church', 'Leadership', 'Me'];

const HQ_ROLES = ['superuser', 'admin'];

// Does this person match one of the roles an item asks for?
function matchesRole(itemRoles, profile) {
  const isHq = HQ_ROLES.includes(profile.role);
  return itemRoles.some((r) => {
    if (r === 'member') return profile.status === 'approved';
    if (r === 'hq') return isHq;
    if (r === 'chapter_leader') return profile.leads_chapter === true;
    return profile.role === r || isHq; // a named role, or HQ
  });
}

export function buildMenu(manifests, enabledIds, profile) {
  const isHq = HQ_ROLES.includes(profile.role);
  const bySection = {};

  manifests.forEach((manifest) => {
    if (!enabledIds.has(manifest.id)) return;
    manifest.items.forEach((item) => {
      if (!matchesRole(item.roles, profile)) return;
      if (item.cnomOnly && !(profile.is_cnom || isHq)) return;
      (bySection[item.section] = bySection[item.section] || []).push({
        page: item.page, label: item.label, icon: item.icon,
      });
    });
  });

  return SECTION_ORDER
    .filter((section) => bySection[section] && bySection[section].length)
    .map((section) => ({ section, items: bySection[section] }));
}
